import GitHub from '../assets/IconsContact/github.svg'
import Angular from '../assets/Tech/angular.png'
import Css from '../assets/Tech/css.png'
import Express from '../assets/Tech/express.png'
import Figma from '../assets/Tech/figma.png'
import Git from '../assets/Tech/git.png'
import Html from '../assets/Tech/html.png'
import Javascript from '../assets/Tech/javascript.png'
import Nodejs from '../assets/Tech/nodejs.png'
import PHP from '../assets/Tech/php.png'
import Postgresql from '../assets/Tech/postgresql.png'
import React from '../assets/Tech/react.png'
import Typescript from '../assets/Tech/typescript.png'
import Scrum from '../assets/Tech/scrum.png'
import Mui from '../assets/Tech/mui.png'

export const techArray = [
    {
        imagem1: Html,
        imagem2: Css,
        nome: 'HTML + CSS',
        conteudo: ["Estrutura organizada e semântica", "Layouts fluidos e responsivos"]
    },
    {
        imagem1: Javascript,
        imagem2: false,
        nome: 'Javascript',
        conteudo: ["Manipulação do DOM", "Fetch API", "Metódos de Arrays", "Recursos ES6", "Programação orientada a objetos"]
    },
    {
        imagem1: Nodejs,
        imagem2: Express,
        nome: 'Node.Js + Express',
        conteudo: ["Criação de API Rest", "Autenticação e Autorização com JWT", "Integração com banco de dados"]
    },
    {
        imagem1: React,
        imagem2: false,
        nome: 'React.js',
        conteudo: ["Hooks nativos e customizados", "Context API", "Componentização", "Integração com Back-End"]
    },
    {
        imagem1: Postgresql,
        imagem2: false,
        nome: 'Postgresql',
        conteudo: ["Criação de tabelas", "Interligar tabelas", "Realizar operações CRUD"]
    },
    {
        imagem1: GitHub,
        imagem2: Git,
        nome: 'Github + Git',
        conteudo: ["Controle e Versionamento dos projetos", "Fluxo de trabalho"]
    },
    {
        imagem1: Figma,
        imagem2: false,
        nome: 'Figma',
        conteudo: ["Reprodução fiel dos layouts"]
    },
    {
        imagem1: Scrum,
        imagem2: false,
        nome: 'Scrum',
        conteudo: ["Reduzir desperdícios", "Agregar valor ao projeto", "Projeto Adaptável e Transparente"]
    },
    {
        imagem1: Mui,
        imagem2: false,
        nome: 'Material UI',
        conteudo: ["Layouts fluidos e responsivos", "Recursos práticos e intuitivos"]
    },
    {
        imagem1: Typescript,
        imagem2: false,
        nome: 'Typescript',
        conteudo: ["Em desenvolvimento"]
    },
    {
        imagem1: Angular,
        imagem2: false,
        nome: 'Angular',
        conteudo: ["Em desenvolvimento"]
    },
    {
        imagem1: PHP,
        imagem2: false,
        nome: 'PHP',
        conteudo: ["Em desenvolvimento"]
    },
]
